<template>
    <section v-if="content != null && dictionary != null" class="booking booking--confirm">
        <div class="booking__main">
            <div class="booking-panel">
                <div class="rte" v-html="content.MainText"></div>

                <Message style="margin-top:30px;" v-if="!paymentSuccess" severity="warn" :closable="false">
                    <div style="line-height:1.5">
                        <p v-if="dictionary.BookingFlowEndMissingPaymentTitle"><b>{{
                            dictionary.BookingFlowEndMissingPaymentTitle }}</b></p>

                        <p v-html="dictionary.BookingFlowEndMissingPaymentText"></p>
                        <br />
                    </div>

                    <div style="display:flex;gap:15px;align-items: center;">
                        <a class="cta-button" style="flex-shrink: 0;"
                            :href="dictionary.BookingFlowEndMissingPaymentLink" target="_blank">{{
                                dictionary.BookingFlowEndMissingPaymentButtonText
                            }}</a>
                        <img src="/assets/images/viabill.png" height="30" style="height:30px;width:auto;" alt=""
                            role="presentation" loading="lazy" />
                        <img src="/assets/images/mobilepay_logo.svg" height="30" style="height:30px;width:auto;" alt=""
                            role="presentation" loading="lazy" />
                    </div>
<br/>
                    <p style="line-height:1.5" v-if="dictionary.BookingFlowEndMissingPaymentContactText">
                        <b>{{ dictionary.BookingFlowEndMissingPaymentContactText }}</b><br/>
                    </p>
                    <a class="cta-button--green" href="#generalContact">{{
                        dictionary.BookingFlowEndMissingPaymentContactButtonText
                        }}</a>
                </Message>
                <Guide v-if="content.HasGuide" :steps="content.Guide"></Guide>
            </div>
        </div>
        <aside class="booking__aside">
            <div class="booking-panel">
                <div class="rte" v-html="content.AsideText">
                </div>

            </div>
            <div class="booking-panel">
                <Help></Help>
            </div>
        </aside>
    </section>
</template>
<script>
import bfdl from './../../bookingFlowDataLayer.js';
import Button from "primevue/button";
import Help from '../components/help.vue';
import bookingQueryKeys from './../booking/bookingQueryKeys.js';
import Guide from './../components/guide.vue';
import Message from 'primevue/message';
export default {
    name: "end",
    components: {
        Button,
        Help,
        Guide,
        Message
    },
    data() {
        return {
            dictionary: null,
            queryKeys: null,
            content: null,
            paymentSuccess: true,
            onLocation: false,
            referrer: null,
        };
    },
    created() {
        const vm = this;
        vm.queryKeys = bookingQueryKeys;

        fetch("/umbraco/api/dictionaryapi/GetBookingEndDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });

        if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search);
            vm.paymentSuccess = searchParams.get(vm.queryKeys.paymentSuccess).toLowerCase() == "true";
            vm.onLocation = searchParams.get(vm.queryKeys.onLocation).toLowerCase() == "true";
            vm.referrer = searchParams.get(vm.queryKeys.referrer);
            const eventName = bfdl.getEventName(vm.referrer);

            if (vm.paymentSuccess && vm.onLocation) {
                bfdl.pushToDataLayer(eventName, bfdl.steps.paySuccessAlarmOn);
            }
            if (vm.paymentSuccess && !vm.onLocation) {
                bfdl.pushToDataLayer(eventName, bfdl.steps.paySuccessAlarmOff);
            }
            if (!vm.paymentSuccess && vm.onLocation) {
                bfdl.pushToDataLayer(eventName, bfdl.steps.payFailAlarmOn);
            }
            if (!vm.paymentSuccess && !vm.onLocation) {
                bfdl.pushToDataLayer(eventName, bfdl.steps.payFailAlarmOff);
            }

            fetch(`/umbraco/api/bookingApi/GetBookingResultContent?paymentSuccess=${vm.paymentSuccess}&onLocation=${vm.onLocation}`).then((response) => response.json())
                .then((data) => {
                    const content = {
                        MainText: data.MainText,
                        AsideText: data.AsideText,
                        Guide: JSON.parse(data.Guide),
                        HasGuide: data.HasGuide
                    }
                    vm.content = content;
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    methods: {

    }
};
</script>
